/*jshint esversion: 11 */

(function () {
    const section = document.currentScript.closest('.bg-sub-shade') || document;
    const carouselWrapper = section.querySelector('.team-carousel-wrapper');
    if (!carouselWrapper) return;

    const viewport = carouselWrapper.querySelector('.team-carousel-viewport');
    const prevBtn  = carouselWrapper.querySelector('.team-carousel-prev');
    const nextBtn  = carouselWrapper.querySelector('.team-carousel-next');
    const cards    = Array.from(carouselWrapper.querySelectorAll('.member'));

    function getCardStep() {
        if (!cards[0]) return 220;
        const style = window.getComputedStyle(viewport.querySelector('.team-carousel-track'));
        const gap = parseFloat(style.gap) || parseFloat(style.columnGap) || 24;
        return cards[0].getBoundingClientRect().width + gap;
    }

    function updateArrows() {
        prevBtn.disabled = viewport.scrollLeft <= 1;
        nextBtn.disabled = viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 1;
    }

    prevBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: -getCardStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: getCardStep(), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', updateArrows, { passive: true });

    updateArrows();
})();